import PropTypes from "prop-types";
import "./styles.css";

function formatNoteLines(note, maxLines = 3) {
  if (!note) return [];

  const lines = note.split("\n");
  const displayLines = lines.length > maxLines ? ["..."].concat(lines.slice(-maxLines)) : lines;

  return displayLines.map((line, index) => {
    if (line === "...") {
      return { key: index, ellipsis: true };
    }

    const [beforeColon, afterColon] = line.split(":", 2);
    const author = beforeColon.trim();

    return {
      key: index,
      author: author ? author.charAt(0).toUpperCase() + author.slice(1) : "",
      text: afterColon ? afterColon.trim() : "",
    };
  });
}

function NoteCell({ customerNote, note, canEdit, onAdd }) {
  const lines = formatNoteLines(note);

  return (
    <div className="note-cell">
      {customerNote ? (
        <div className="note-card note-card--customer">
          <div className="note-card__head">
            <span className="note-card__label">Customer</span>
          </div>
          <div className="note-card__body">{customerNote}</div>
        </div>
      ) : null}

      {note ? (
        <div className="note-card">
          {canEdit ? (
            <button type="button" className="note-card__edit" onClick={onAdd} title="Add note">
              +
            </button>
          ) : null}
          <div className="note-card__body">
            {lines.map((line) =>
              line.ellipsis ? (
                <div key={line.key} className="note-line note-line--more">
                  …
                </div>
              ) : (
                <div key={line.key} className="note-line">
                  {line.author ? (
                    <div className="note-line__meta">
                      <span className="note-line__avatar">{line.author.charAt(0)}</span>
                      <span className="note-line__author">{line.author}</span>
                    </div>
                  ) : null}
                  {line.text ? <span className="note-line__text">{line.text}</span> : null}
                </div>
              )
            )}
          </div>
        </div>
      ) : null}

      {canEdit && !note ? (
        <button type="button" className="note-add" onClick={onAdd}>
          Add note
        </button>
      ) : null}
    </div>
  );
}

NoteCell.propTypes = {
  customerNote: PropTypes.string,
  note: PropTypes.string,
  canEdit: PropTypes.bool,
  onAdd: PropTypes.func,
};

NoteCell.defaultProps = {
  customerNote: "",
  note: "",
  canEdit: false,
  onAdd: undefined,
};

export default NoteCell;
